import { Text, TextProps } from "react-native";

export const StyledText = (props: TextProps) => {
  const { className = "", ...rest } = props;
  return <Text className={`${className}`} {...rest} />;
};

export default StyledText;
